import { render, staticRenderFns } from "./odiv-ckd.vue?vue&type=template&id=bbd8a838&scoped=true&"
import script from "./odiv-ckd.vue?vue&type=script&lang=js&"
export * from "./odiv-ckd.vue?vue&type=script&lang=js&"
import style0 from "./odiv-ckd.vue?vue&type=style&index=0&id=bbd8a838&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd8a838",
  null
  
)

export default component.exports